$('body').on('click', '.personify-brand', function () {
  var $this = $(this);
  var id = $this.data('id');
  $('.personify-brand-lines').hide();
  $('.personify-brand-lines[data-id=' + id + ']').css('display', 'flex');
  $('.personify-brand.is-active').removeClass('is-active');
  $this.addClass('is-active');
});

$('.personify-brand-lines').not(':first').hide();
$('.personify-brand').first().click();

$('body').on('click', '.personify-department', function (e) {
  e.preventDefault();
  var $this = $(this);
  var id = $this.data('id');
  $('.personify-attributes').hide();
  $('.personify-attributes[data-id=' + id + ']').css('display', 'flex');
  $('.personify-department.is-active').removeClass('is-active');
  $this.addClass('is-active');
});

$('.personify-attributes').not(':first').hide();
$('.personify-department').first().click();
